import { createSelector } from 'reselect'

export const getAuthError = createSelector(
  state => state && state.user && state.user.auth && state.user.auth.error ? state.user.auth.error : null,
  error => error
)
